import { useSelector } from 'react-redux';

import { Grid } from '@mui/material';

import { wrapper } from '../../redux/store';
import { getAllCategories } from '../../redux/actions/categories.action';

import Breadcrumb from '../../components/Common/Breadcrumb.component';
import ContentBox from '../../components/Common/ContentBox.component';
import CustomCard from '../../components/Common/CustomCard.component';

const listBreadcrumbChildren = [
  {
    name: 'Thể loại',
    href: '/categories',
  },
];

const Categories = () => {
  const { allCategories } = useSelector((state) => state.categories);

  return (
    <div>
      <Breadcrumb listBreadcrumbChildren={listBreadcrumbChildren} />
      <ContentBox title="Thể loại">
        <Grid container spacing={5}>
          {allCategories.map((category) => (
            <Grid item xs={12} sm={6} md={4} key={category._id}>
              <CustomCard info={category} infoType="categories" />
            </Grid>
          ))}
        </Grid>
      </ContentBox>
    </div>
  );
};

export const getStaticProps = wrapper.getStaticProps(
  (store) =>
    async ({ req }) => {
      await store.dispatch(getAllCategories(req));
    }
);

export default Categories;
